export enum FlowSequenceCompleteStrategy {
    END_FLOW = "end_flow",
    END_FLOW_IN_ERROR = "end_flow_in_error",
    LINK = "link",
    RETURN_TO_CALLING_STEP = "return_to_step",
}
